import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from "./URLCatalog";
import { Alert, Subscription } from "@models/Alertas";


export interface QontactPointSearchResult {
    objectID: string;
    buildingName: string;
    isListableQP: boolean;
    organizationID: string;
    buildingID: string;
    functionalUnitID: string;
    id: string;
    location: {
        latitude: number;
        longitude: number;
    };
    shiftTotal: number;
    triggerDistance?: number;
}

/** "with" = only qontact points with shifts, "without" = only without */
export type QontactPointShiftsFilter = "with" | "without";

export interface QontactPointShiftsCounts {
    all: number;
    withShifts: number;
    withoutShifts: number;
}

export interface QontactPointSearchV2Result {
    hits: QontactPointSearchResult[];
    nbHits: number;
    /** Only present when requested with includeCounts */
    counts?: QontactPointShiftsCounts;
}

export class AlgoliaService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async searchQontactPoints(orgId: string, query: string, page: number, hits_per_page?: number, opts?: { signal?: AbortSignal }): Promise<QontactPointSearchResult[]> {
        const url = buildURL(SystemURL.Algolia.getSearchQontactPoints, {
            org_id: orgId,
            query: encodeURIComponent(query),
            number: page.toString(),
            hits_per_page: hits_per_page ? hits_per_page.toString() : "20",
        });

        const request = new HTTPRequest();
        request.url = url;
        request.method = "GET";
        if (opts?.signal) {
            request.signal = opts.signal;
        }

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async searchQontactPointsV2(
        orgId: string,
        query: string,
        page: number,
        hits_per_page?: number,
        opts?: { signal?: AbortSignal; shifts?: QontactPointShiftsFilter; includeCounts?: boolean }
    ): Promise<QontactPointSearchV2Result> {

        let url = buildURL(SystemURL.Algolia.getSearchQontactPointsV2, {
            org_id: orgId,
            query: encodeURIComponent(query),
            number: page.toString(),
            hits_per_page: hits_per_page ? hits_per_page.toString() : "20",
        });
        const extraParams: string[] = [];
        if (opts?.shifts) {
            extraParams.push(`shifts=${opts.shifts}`);
        }
        if (opts?.includeCounts) {
            extraParams.push("includeCounts=true");
        }
        if (extraParams.length > 0) {
            url += (url.includes("?") ? "&" : "?") + extraParams.join("&");
        }

        const request = new HTTPRequest();
        request.url = url;
        request.method = "GET";
        if (opts?.signal) {
            request.signal = opts.signal;
        }

        const response = await this.httpClient.execute(request);

        return response.result as QontactPointSearchV2Result;
    }
    
}
